export default __webpack_public_path__ + "static/media/riyadh.8f1bbeb3.mp4";